<div class="navbar-header" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">
    <div class="logo">
        @if (entryPointResources === "") {
            <img class="logo-icon" src="assets/images/logos/logo_header_min.png" fxHide.lt-lg />
        }
        @if (entryPointResources !== "") {
            <img class="logo-icon" [src]="getLogoHeader()" fxHide.lt-lg />
        }
        @if (entryPointResources !== "") {
            <img class="logo-text" [src]="getLogoHeader()" fxHide.gt-md />
        }
        @if (projectConf) {
            <span class="logo-text" fxHide.lt-lg>{{ projectConf.appName }}</span>
        }
    </div>

    <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()" fxHide.lt-lg>
        <mat-icon style="color: var(--feedbalia-color-sidebar-text-500) !important">menu</mat-icon>
    </button>

    <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
        <mat-icon style="color: var(--feedbalia-color-sidebar-text-500) !important">arrow_back</mat-icon>
    </button>
</div>

<div
    class="navbar-content"
    fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
    [ngClass]="fuseConfig.layout.navbar.primaryBackground"
>
    <fuse-navigation layout="vertical"></fuse-navigation>
</div>
